import { createFileRoute } from '@tanstack/react-router';

import { ProceedingSearchClaimable } from '@/module/Author/Proceeding/ProceedingSearchClaimable';

export const Route = createFileRoute('/_auth/author/_author/proceeding/_proceeding/search-claimable')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.create' },
  },
});

function RouteComponent() {
  return <ProceedingSearchClaimable />;
}
